import Button from '@mui/material/Button'
import useMediaQuery from '@mui/material/useMediaQuery'
import { useTheme } from '@mui/material/styles'
import React from 'react'
import AddIcon from '@mui/icons-material/Add'
import { getButtonTestId } from './getButtonTestId'

/** @notExported */
interface GreenAddButtonProps {
  /** Action to be performed when the button is clicked. */
  clickAction: () => void
  /** Whether the button should be disabled. */
  valid: boolean
  /** Label of the button. */
  label: React.ReactNode
  /** Test id of the button. */
  testId?: string
}

/**
 * Green add button.
 *
 * @returns Green add button component.
 * @notExported
 * @category Buttons
 */
const GreenAddButton: React.FC<GreenAddButtonProps> = ({ clickAction, valid, label, testId }) => {
  const theme = useTheme()
  const mobileView = useMediaQuery(theme.breakpoints.down('sm'))
  const resolvedTestId = getButtonTestId({ fallback: 'button-green-add', label, testId })
  return (
    <Button
      id="search"
      data-testid={resolvedTestId}
      type="button"
      variant="contained"
      disabled={!valid}
      onClick={() => clickAction()}
      color="success"
      sx={{ margin: mobileView ? 1 : 0 }}
      startIcon={mobileView ? undefined : <AddIcon />}
    >
      {mobileView ? <AddIcon /> : label}
    </Button>
  )
}

export default GreenAddButton
